// extracted by css-extract-rspack-plugin
export default {"content":"_68b9a73d","expanded":"_36b91f93"};